(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expressluv-moments')) {
    customElements.define('expressluv-moments', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.au-moments-track');
        this.previous = this.querySelector('[data-moment-prev]');
        this.next = this.querySelector('[data-moment-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const update = () => {
          const end = this.track.scrollWidth - this.track.clientWidth;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= end - 2;
        };
        const move = (direction) => {
          const card = this.track.querySelector('.au-moment');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: reduced ? 'auto' : 'smooth'});
        };
        this.previous.addEventListener('click', () => move(-1), {signal});
        this.next.addEventListener('click', () => move(1), {signal});
        this.track.addEventListener('scroll', update, {passive: true, signal});
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expressluv-account"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-elv-account]').forEach(function(section){
    section.querySelectorAll('[data-account-mode]').forEach(function(button){
      button.addEventListener('click',function(){
        section.querySelectorAll('[data-account-mode]').forEach(function(tab){tab.setAttribute('aria-pressed',String(tab===button));});
        section.querySelectorAll('[data-account-note]').forEach(function(note){note.hidden=note.dataset.accountNote!==button.dataset.accountMode;});
        var cta=section.querySelector('[data-account-cta]');
        if(cta)cta.textContent=button.textContent;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
